<div class="login-layout">
  <main class="login-content">
    <app-login></app-login>
  </main>

  <app-footer></app-footer>
</div>
